import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './rem.js';
import './assets/css/default.less'
import axios from 'axios'
import API from '@/api.js'
import ajax from '@/ajax.js'
import { getCookie } from '@/utils'
import 'vant/lib/icon/local.css';

import {
  Button,
  Icon,
  Field, 
  Form, 
  Toast,
  List,
  DatetimePicker,
  Popup,
  Picker,
  Checkbox, 
  CheckboxGroup
} from 'vant';
Vue.use(Button)
  .use(Icon)
  .use(Field)
  .use(Form)
  .use(Toast)
  .use(List)
  .use(DatetimePicker)
  .use(Popup)
  .use(Picker)
  .use(Checkbox)
  .use(CheckboxGroup)
  ;
  
Vue.prototype.$axios = axios
Vue.prototype.API = API
Vue.prototype.$patch = ajax.patch
Vue.prototype.$get = ajax.get
Vue.prototype.$post = ajax.post
Vue.prototype.$put = ajax.put
Vue.prototype.$del = ajax.del
Vue.prototype.$Toast = Toast

Vue.config.productionTip = false

router.beforeEach(async(to, from, next) => {
  // determine whether the user has logged in
  const hasToken = getCookie('userData')
  if(to.name === "Login"){
    if(hasToken){
      next({name:"Home"})
    }else{
      next()
    }
  }else{
    if(hasToken){
      next()
    }else{
      next({name:"Login"})
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
